import React from 'react';
import { string } from 'prop-types';
import Fade from '@material-ui/core/Fade';
import Base, { H2, Icon, Root, P, FADE_TIMEOUT, ImgContainer, CopyContainer } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

// @ts-expect-error ts-migrate(2417) FIXME: Type '{ carrier: Validator<string>; planType: Vali... Remove this comment to see the full error message
class Overview extends Base {
  static propTypes = {
    carrier: string.isRequired,
    planType: string.isRequired,
  };

  static isVisible = () => true;

  icon = '/images/insurance_tutorial/02_basics.svg';

  getPlanString = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'planType' does not exist on type 'Readon... Remove this comment to see the full error message
    const { planType } = this.props;
    return isEmpty(planType) ? 'plan' : planType.toUpperCase();
  };

  render = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'carrier' does not exist on type 'Readonl... Remove this comment to see the full error message
    const { carrier } = this.props;
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>The basics</H2>

            <P>
              Your <b>{carrier}</b> plan works like this: there's usually a monthly fee&mdash;a
              premium&mdash;you pay to have health insurance so you're covered when you or someone
              in your family gets sick, injured, or needs to see a doctor.
            </P>
            {this.getPlanString().toUpperCase() === 'COMMERCIAL' && (
              <P>
                Keep in mind, not everything is covered by your plan. You don't want to get caught
                in a pickle so if you’re not sure what’s covered, double check.
              </P>
            )}
            {this.getPlanString().toUpperCase() !== 'COMMERCIAL' && (
              <P>
                Keep in mind, not everything is covered by your <b>{this.getPlanString()}</b>. You
                don't want to get caught in a pickle so if you’re not sure what’s covered, double
                check.
              </P>
            )}
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default Overview;
